<template>
        <div class="b2b-checkout-review">
            <div>
                <Teleport v-if="documentReady" to="#review-header-place-order-btn">
                    <div class="review-header">
                        <RothcoCta :class="{'primary': canPlaceOrder, 'disabled': !canPlaceOrder, 'submit-order': true}" :disabled="!canPlaceOrder" :button_icon="false" 
                            :href="checkoutStoreRoute" method="post" :data="formData">
                            Place {{ isQuote ? 'Quote' : 'Order' }}
                        </RothcoCta>
                    </div>
                </Teleport>
                <div class="b2b-checkout-wrapper">
                    <!-- B2B ORDER SUMMARY-->
                    <div class="b2b-order-summary">
                        <div class="b2b-card error">
                            <div v-if="(hasItemErrors || unavailableInventoryItems.length > 0) && hasOrderLinesWithQuantity && !isFetching" class="header">
                                <h2 class="title-m">There may be issues with items in your order. <span class="desktop-hidden-contents"><a href="#" class="text-rothcoWhite paragraph-feature" @click.prevent="scrollToItemsGrid()"> View Items</a></span></h2>
                                <a href="#" class="text-rothcoWhite paragraph-feature mobile-hidden" @click.prevent="scrollToItemsGrid()">View Items</a>
                            </div>
                            <div v-else-if="props.errors.error == 'no-items' || !hasOrderLinesWithQuantity" class="header">
                                <h2 class="title-m">There are no items on your {{ isQuote ? 'quote' : 'order' }}. <span class="desktop-hidden-contents"><Link :href="route('index.quickOrdering')" class="text-rothcoWhite paragraph-feature"> Click to Return to Quick Order Entry</Link></span></h2>
                                <Link :href="route('index.quickOrdering')" class="text-rothcoWhite paragraph-feature mobile-hidden">Click to Return to Quick Order Entry</Link>
                            </div>
                            <div v-else-if="props.errors.error && props.errors.error != 'no-items'" class="header">
                                <h2 class="title-m">Error:<span class="text-rothcoWhite paragraph-feature desktop-hidden-contents">{{ props.errors.error }}</span></h2>
                                <span class="text-rothcoWhite paragraph-feature mobile-hidden">{{props.errors.error}}</span>
                            </div>
                            <div class="content">
                                <div class="content-head">
                                    <div class="headline-s title">Summary</div>
                                    <a href="#" @click.prevent="scrollToItemsGrid()">View Items In {{ isQuote ? 'Quote' : 'Order' }}</a>
                                </div>
                                <div class="row">
                                    <div class="paragraph-default col-title">Quantity</div>
                                    <div class="quantity-container">
                                        <div class="paragraph-default">{{ totalStyles }} Styles</div>
                                        <div class="paragraph-default bar-styling">|</div>
                                        <div class="paragraph-default">{{ totalSkus }} SKUs</div>
                                        <div class="paragraph-default bar-styling">|</div>
                                        <div class="paragraph-default">{{ totalQuantity }} Quantity</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="paragraph-default col-title">Approx. Wgt</div>
                                    <div class="paragraph-default">{{ approxWeight.toFixed(2) }}lbs</div>
                                </div>
                                <div class="row">
                                    <div class="paragraph-default col-title">Merchandise</div>
                                    <div class="paragraph-default">${{ merchandiseCost }}</div>
                                </div>
                                <div class="row" v-if="parseFloat(shippingCost) > 0">
                                    <div class="paragraph-default col-title">Shipping</div>
                                    <div class="paragraph-default">${{ shippingCost }}</div>
                                </div>
                                <div v-if="shipping.drop_ship == 1" class="row">
                                    <div class="paragraph-default col-title">Dropship Fee</div>
                                    <div class="paragraph-default"><i>${{ formatPrice(props.dropshipFee) }}</i></div>
                                </div>
                                <!-- <div class="row">
                                    <div class="paragraph-default col-title">Discounts</div>
                                    <div class="paragraph-default text-rothcoRed"><i>-${{ totalDiscounts }}</i></div>
                                </div> -->
                                <div class="row">
                                    <div class="total-value-title"><strong>Total</strong></div>
                                    <div class="total-value">${{ totalCost }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- B2B SHIPPING & BILLING-->
                    <div class="b2b-shipping-billing-summary">
                        <shipping-confirm v-model="shipping" :allowEdit="true" :mustShip="mustShip" ref="shippingConfirm"/>
                        <billing-confirm v-model="billing" :allowEdit="true" :paymentMethods="paymentMethods" ref="billingConfirm"/>
                    </div>
                    
                </div>
            
                <!-- B2B ITEMS IN ORDER-->
                <div class="b2b-items-in-order-summary" id="tableContainer">
                    <div class="title-container">
                        <div class="title-l">Items in {{ isQuote ? 'Quote' : 'Order' }}</div>
                        <div class="content text-rothcoText">
                            <div class="paragraph-default">{{ totalStyles }} Styles</div>
                            <div class="paragraph-default">|</div>
                            <div class="paragraph-default">{{ totalSkus }} SKUs</div>
                            <div class="paragraph-default">|</div>
                            <div class="paragraph-default">{{ totalQuantity }} Quantity</div>
                            <div class="paragraph-default">|</div>
                            <div class="paragraph-default">Approx. Wgt: {{ approxWeight.toFixed(2) }}lbs</div>
                        </div>
                    </div>

                    <div class="b2b-items-in-order-table">
                        <rothco-table
                            class="table"
                            key="table"
                            v-model:content="gridItems"
                            :visible-fields="visibleFields"
                            :expandedRows="expandedRows"
                            :primeVueProps="{
                                expandedRows, editMode: 'cell', 
                            }"
                            dataKey="list_item_id"
                            :pt="{
                                bodyRow: {
                                    class: 'table-item table-item-3-col'
                                },
                                rowExpansion: {
                                    class: 'error-row'
                                }
                            }">

                            <template v-for="(item, index) in gridItems" :key="`item_name_${index}`" v-slot:[`item_name_${index}`]="slotProps">
                                <a v-if="slotProps.header.show_only == 'mobile'" class="card-title" target="_blank" :href="pdpRoute(item)">
                                    {{ item.data.item_name }}
                                </a>
                                <a v-else class="table-name paragraph-default" target="_blank" :href="pdpRoute(item)">
                                    {{ item.data.item_name }}
                                </a>
                                <TrashIcon v-if="slotProps.header.show_only == 'mobile'" class="remove-icon mobile-only" :alt="`Remove product ${item.data.item_name}`" aria-label="Remove product" :id="`mobile_delete_list_item_${index}`"
                                    @click="deleteItem(slotProps.data.data)" />    
                            </template>

                            <template v-for="(item, index) in gridItems" :key="`variants_badges_${index}`" v-slot:[`variants_badges_${index}`]="slotProps">
                                <div class="badge-wrapper">
                                    <p v-if="Object.keys(item?.data?.variants_badges ?? {}).length === 0" class="paragraph-default badge" style="visibility: hidden">No Variants</p>
                                    <p v-for="(variantValue,i) in (item.data.variants_badges ?? {})" :key="i" class="paragraph-default badge">{{ variantValue }}</p>
                                </div>
                            </template>

                            <template v-for="(item, index) in gridItems" :key="`price_${index}`" v-slot:[`price_${index}`]="slotProps">
                                <span>
                                    ${{ parseFloat(item.data.price).toFixed(2) }}
                                </span>
                            </template>

                            <template v-for="(item, index) in gridItems" :key="`cost_${index}`" v-slot:[`cost_${index}`]="slotProps">
                                <span>
                                    ${{ formatTotalPrice(item.data.price, item.data.quantity) }}
                                </span>
                            </template>
                            <template
                                v-for="(item, index) in gridItems"
                                :key="`quantity_${index}`"
                                v-slot:[`quantity_${index}`]="slotProps"
                            >
                                <input
                                        :id="`quantity_${slotProps.data.list_item_id}_input`"
                                        v-model="slotProps.data.data.quantity"
                                        :class="{'table-input mob-text-left desk-text-center': true, 'invalid-state-input': !validateQuantity(slotProps.data.data.quantity)}"
                                        type="number" min="1" step="1" max="1000000" autocomplete="off" @wheel.prevent="blurOnWheel"
                                        @blur="handleQuantityInput(slotProps.data.data)"
                                    />
                            </template>

                            <template v-for="(item, index) in gridItems" :key="`delete_${index}`" v-slot:[`delete_${index}`]="slotProps">
                                <TrashIcon class="remove-icon" :alt="`Remove product ${item.data.item_name}`" aria-label="Remove product" :id="`desktop_delete_list_item_${index}`"
                                    @click="deleteItem(slotProps.data.data)"/>
                            </template>

                            <template v-slot:[`expansion`]="slotProps">
                                <div class="notification notification-error">
                                    <ShoppingCartIcon class="icon" alt="cart error icon" />
                                    <div class="error-content">
                                        <div class="error-text">
                                            <div v-if="hasUnavailableInventory(slotProps.data.data)" class="paragraph-details text-rothcoWhite bold">
                                                This product does not currently have enough inventory to complete your order.
                                            </div>
                                            <div v-if="isRestricted(slotProps.data.data)" class="paragraph-details text-rothcoWhite bold">
                                                {{ getRestrictionMessage(slotProps.data.data) }}
                                            </div>
                                        </div>
                                        <div class="error-links">
                                            <template v-if="hasUnavailableInventory(slotProps.data.data)">
                                                <a href="#" class="text-rothcoWhite paragraph-details" @click.prevent="convertToQuote">Convert Order to Quote</a>
                                                <span class="mobile-hidden paragraph-details">|</span> 
                                            </template>
                                            <template v-if="hasUnavailableInventory(slotProps.data.data)">
                                                <a href="#" class="text-rothcoWhite paragraph-details" @click.prevent="changeQuantity(slotProps.data.list_item_id)">Change Quantity ({{ slotProps.data.data.variation.inventory_level }} Available)</a>
                                                <span class="mobile-hidden paragraph-details">|</span>
                                            </template>
                                            <a href="#" class="text-rothcoWhite paragraph-details" @click.prevent="deleteItem(slotProps.data.data)">Remove</a>
                                        </div>
                                    </div>
                                </div>
                            </template>

                        </rothco-table>
                    </div>
                </div>

                <!-- B2B ORDER TOTAL-->
                <div class="b2b-order-total-summary">
                    <section class="summary-section">
                        <div class="summary-container">
                            <dl>
                                <dt class="paragraph-default">Merchandise</dt>
                                <dd class="paragraph-default">${{ merchandiseCost }}</dd>
                            </dl>
                            <!-- <dl>
                                <dt class="paragraph-default">Discounts</dt>
                                <dd class="paragraph-default text-rothcoRed font-italic">${{ discountAmount }}</dd>
                            </dl> -->
                            <dl v-if="shipping.drop_ship == 1">
                                <dt class="paragraph-default">Dropship Fee</dt>
                                <dd class="paragraph-default">${{ formatPrice(props.dropshipFee) }}</dd>
                            </dl>
                            <dl v-if="parseFloat(shippingCost) > 0">
                                <dt class="paragraph-default">Shipping</dt>
                                <dd class="paragraph-default">${{ shippingCost }}</dd>
                            </dl>
                            <dl>
                                <!-- <dt class="paragraph-default">Taxes</dt>
                                <dd :class="{'font-italic': isTaxExempt || tax == 0, 'paragraph-default': true}">{{ isTaxExempt ? 'Tax Exempt' : tax == 0 ? 'Processing' : `$${formatPrice(props.tax)}` }}</dd> -->
                                <dd :class="{'font-italic': true, 'paragraph-default': true}">Tax is calculated at shipping for non-tax-exempt customers.</dd>
                            </dl>
                            <dl class="order-total">
                                <dt class="title-l">{{ isQuote ? 'Quote' : 'Order' }} Total</dt>
                                <dd class="title-l">${{ totalCost }}</dd>
                            </dl>
                            <dl v-if="splitOrder">
                                <div class="paragraph-details text-rothcoText mob-text-center">
                                    You have a large quantity of items in your cart
                                    that require California Prop 65 labeling and
                                    could delay your order by 1 - 2 days. To receive
                                    items that do not require labeling sooner, you
                                    can automatically split your order into two. You
                                    will receive separate confirmations for each
                                    order.
                                </div>
                            </dl>
                            <dl v-if="splitOrder" style="justify-content: center; gap: 2rem;">
                                <label for="split_prop_65">
                                    <input 
                                        v-model="split_list_by_prop65"
                                        type="radio"
                                        :value="false" 
                                        id="place1Order" 
                                        name="split_prop_65" 
                                        aria-label="Place 1 order">
                                        Place 1 Order
                                </label>
                                <label for="split_prop_65">
                                    <input 
                                        v-model="split_list_by_prop65"
                                        type="radio"
                                        :value="true" 
                                        id="place2Order" 
                                        name="split_prop_65" 
                                        aria-label="Place 2 orders">
                                        Place 2 Orders
                                </label>
                            </dl>
                            <RothcoCta id="place_order_button" :class="{'primary': canPlaceOrder, 'disabled': !canPlaceOrder, ' desk-text-center mob-text-center submit-order': true}" :disabled="!canPlaceOrder" button_icon="" 
                                :href="checkoutStoreRoute" method="post" :data="formData">
                                Place {{ isQuote ? 'Quote' : 'Order' }}
                            </RothcoCta>
                            <div class="paragraph-details text-rothcoText mob-text-center">
                                Please review all details of your order above. Orders cannot be changed once placed.
                            </div>
                            <div class="paragraph-details text-rothcoText shipping-not-included-text">
                                Does not include shipping.
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
</template>

<script setup lang="ts">
    import { ref, computed, toRefs, nextTick, inject, onMounted } from "vue";
    import { usePage, router, Link } from "@inertiajs/vue3";
    import ShippingConfirm from "@/components/ShippingConfirm.vue";
    import BillingConfirm from "@/components/BillingConfirm.vue";
    import RothcoTable from "@/components/RothcoTable.vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { type List } from "@interfaces/List";
    import ListDeleteForm from "@/components/ListDeleteForm.vue";
    import { useFetch } from "@/helpers/composables/useFetch";
    import { useLists } from "@/helpers/composables/useList";
    import { useDialog } from "primevue/usedialog";
    import { useSettingsStore } from "@/store/settings";
    import { storeToRefs } from "pinia";
    import moment from "moment";
    import { formatPrice, formatTotalPrice } from "@/helpers/composables/usePriceFormatting";
    import ShoppingCartIcon from "@icons/carbon_shopping-cart-error.svg";
    import TrashIcon from "@icons/remove-icon.svg";
    import Prop65OrderWarningModal from "@/components/Prop65OrderWarningModal.vue";
    import useGoogleManager from "@/helpers/composables/google";
    const props = defineProps({
        shippingCountry: {
            type: Object,
            default(){
                return {}
            }
        },
        shippingRegion: {
            type: Object,
            default(){
                return {}
            }
        },
        finalAddressCountry: {
            type: Object,
            default(){
                return {}
            }
        },
        finalAddressRegion: {
            type: Object,
            default(){
                return {}
            }
        },
        billing: {
            type: Object,
            default: () => ({
                billing_po_number: "",
                billing_email: "",
                billing_alternate_email: "",
                order_type: "",
                billing_payment_method: "",
                billing_comments: "",
                billing_campaign_code: "",
                creditCard: {
                    cc_last_4: ""
                }
            })
        },
        shipping: {
            type: Object,
            default: () => ({
                drop_ship: "",
                blind: "",
                name: "",
                in_care_of: "",
                address: "",
                address_2: "",
                city: "",
                state: "",
                country: "",
                final_destination: "",
                postal_code: "",
                phone: "",
                email_tracing_info: "",
                collectAccount: null
            })
        },
        mustShip: {
            type: Object,
            default: () => {
                return {};
            }
        },
        tax: {
            type: [Number,String],
            default: 0
        },
        paymentMethods: {
            type: Array,
            default: () => {
                return [];
            }
        },
        flashMessage: {
            type: String,
            default: ""
        },
        current_list: {
            type: Object as PropType<List>,
            default: () => ({})
        },
        items: {
            type: Array as PropType<Array<any>>,
            default: () => []
        },
        isTaxExempt: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Object,
            default: () => {}
        },
        dropshipFee: {
            type: [Number, String],
            default: 0
        },
        ignoreRestrictionDataForTest: {
            type: Boolean,
            default: false
        }
        })
        const shippingConfirm = ref(null);
        const billingConfirm = ref(null);

    let { items, billing, shipping } = toRefs(props);
    let route = inject("route");

    function scrollToItemsGrid() {
        document.getElementById('tableContainer')?.scrollIntoView?.({ behavior: "smooth" });
    }

    const flashMessage = computed(() => props?.flashMessage ?? []);
    // const form = useForm("DealerCheckout/Review", {
    //     billing: JSON.parse(JSON.stringify(billing.value)),
    //     shipping: JSON.parse(JSON.stringify(shipping.value)),
    //     split_list_by_prop65: false,
    // });

    const editingFields = computed(()=>{
        return {
            ...(shippingConfirm?.value?.editingFields ?? {}),
            ...(billingConfirm?.value?.editingFields ?? {})
        }
    })
    const formData = computed(()=>{

    const mustShipDate = editingFields.value['shipping_must_ship_date'] ?? shipping.value.shipping_must_ship_date;
    return {
        billing_email: billing.value.billing_email,
        billing_alternate_email: billing.value.billing_alternate_email,
        billing_phone: billing.value.billing_phone,
        campaign: billing.value.billing_campaign_code,
        list_id: props.current_list.list_id,
        drop_ship: shipping.value.drop_ship,
        credit_card_id: billing.value.billing_credit_card_id,
        po_number: editingFields.value['billing_po_number'] ?? billing.value.billing_po_number,
        payment_method: billing.value.billing_payment_method,
        order_type: billing.value.order_type,
        billing_comments: editingFields.value['billing_comments'] ?? billing.value.billing_comments,
        ship_blind: shipping.value.ship_blind,
        in_care_of: shipping.value.shipping_in_care_of,
        must_ship_date: mustShipDate ?  moment(mustShipDate).format('YYYY-MM-DD HH:mm:ss') : null,
        shipping_comments: editingFields.value['shipping_comments'] ?? shipping.value.shipping_comments,
        shipping_customer_code: shipping.value.shipping_customer_code,
        shipping_service_level: shipping.value.shipping_service_level,
        shipping_method: shipping.value.shipping_method,
        shipping_name: shipping.value.shipping_name,
        shipping_address: shipping.value.shipping_address,
        shipping_address_2: shipping.value.shipping_address_2,
        shipping_city: shipping.value.shipping_city,
        shipping_state: shipping.value.shipping_state,
        shipping_country: shipping.value.shipping_country,
        shipping_zip: shipping.value.shipping_zip,
        shipping_phone: shipping.value.shipping_phone,
        shipping_email: shipping.value.shipping_email,
        final_destination_state:
            shipping.value.shipping_final_destination_state,
        final_destination_country:
            shipping.value.shipping_final_destination_country,
        freight_payment_term: shipping.value.freight_payment_term,
        collect_no_id: shipping.value.collect_no_id,
        split_list_by_prop65: split_list_by_prop65.value,
        }
    });

    // let canSetMustShipDate = computed(() => {
    //     return props.mustShip.isShowMustShipDate;
    // });

    let split_list_by_prop65 = ref(false);

    let isShowShippingCost = computed(() => {
        return false;
    });
    let shippingCost = computed(() => {
        return formatPrice(0);
    });
    let showItemWarningMessage = computed(() => {
        return false;
    });
    let arrRestricted = computed(() => {
        return [];
    });
    let arrRestrictedMsgs = computed(() => {
        return {};
    });
    let itemsWithLimitedInventory = computed(() => {
        return {};
    });

    const merchandiseCost = computed(() => {
        return formatPrice(
            items.value
                .reduce((total, item) => {
                    return (
                        total + +formatTotalPrice(item.price, item.quantity)
                    );
                }, 0).toFixed(2) ?? 0
        );
    });
    const totalCost = computed(() => {
        return formatPrice(+merchandiseCost.value + +shippingCost.value + +formatPrice(props.dropshipFee));
    });

    const totalItems = computed(() => {
        let variationMap = new Map();
        items.value.forEach((item) => {
            let variation = item.variation;
            if (variationMap.has(variation.item_variation_id)) {
                variationMap.set(variation.item_variation_id, {
                    quantity: variationMap.get(variation.item_variation_id).quantity + item.quantity,
                    variation: variation
                });
            } else {
                variationMap.set(variation.item_variation_id, {
                    quantity: item.quantity,
                    variation: variation
                });
            }
        });
        return variationMap.size;
    });

    const totalQuantity = computed(() => {
        return items.value.reduce((total, item) => {
            return total + item.quantity;
        }, 0);
    });

    const totalSkus = computed(() => 
        new Set(items.value.map(item => item.variation.item_variation_id)).size
    );

    const totalStyles = computed(() => {
        return new Set(items.value.map(item => item.variation.rothcoItem.rothco_item_no)).size
    });

    const approxWeight = computed(() => {
        return items.value.reduce((weight, item) => {
            return weight + +item.variation.weight * item.quantity;
        }, 0);
    });

    const getVariant = (variation) => {
        try {
            return Object.values(variation).join(" - ");
        } catch (e) {
            return "";
        }
    };

    let restrictionPayload = computed(() => ({
        final_address: {
            country_id: props.finalAddressCountry?.country_id ?? "",
            region_id: props.finalAddressRegion?.region_id,
        },
        options: {
            country_id: props.shippingCountry?.country_id ?? "",
            region: props.shippingRegion?.region_id,
            postal_code: shipping.value.zip,
            customer: usePage()?.props?.session?.site_rothco_dealer_no,
            is_quote: billing.value.order_type?.toLowerCase?.() === "quote",
            shipping_method: shipping.value.shipping_method
        },
        order_skus: items.value.map((item) => ({
            quantity: item.quantity,
            price: item.price,
            upc: item.variation.upc
        }))
    }));

    let { data: restrictionData, isFetching, execute } = useFetch(
        route("web.restrictions.check.order")
    )
        .post(restrictionPayload.value)
        .json();
    let restrictedItems = computed(() => {
        return items.value.reduce((acc, item) => {
            let restrictions = restrictionData.value?.data?.skus;
            if (restrictions) {
                let restrictedSku = restrictions.find(
                    (restriction) => restriction.upc == item.variation.upc
                );
                if (restrictedSku?.is_restricted) {
                    acc.push(item);
                }
            }
            return acc;
        }, []);
    });
    let unavailableInventoryItems = computed(() => {
        return billing.value.order_type == "Order" ? gridItems.value?.filter((gridItem=>hasUnavailableInventory(gridItem.data))) : [];
    });

    const hasOrderLinesWithQuantity = computed(()=>((gridItems.value.length > 0) && gridItems.value.every((item)=>(+item.data.quantity > 0))))

    const hasItemErrors = computed(()=>{
        return props.ignoreRestrictionDataForTest || !restrictionData.value?.data?.skus.every((sku) => {
            let isHardRestriction = sku.has_hard_restrictions;
            let isSoftRestriction = sku.is_restricted && !isHardRestriction;
            let skuExists = items.value.find(
                (item) => item.variation.upc == sku.upc
            );
            if(!skuExists){
                return true;
            }
            return (
                !isHardRestriction && (!isSoftRestriction || allowRestrictedItems.value)
            );
        });
    })
    const hasShippingInfoErrors = computed(()=>{
        return Object.keys(shippingConfirm?.value?.formErrors ?? {}).length > 0
    })

    let canPlaceOrder = computed(() => {
        return !hasItemErrors.value && unavailableInventoryItems.value.length == 0 && !hasShippingInfoErrors.value && hasOrderLinesWithQuantity.value;
    });

    let expandedRows = computed(() => {
        let arr = [
            ...restrictedItems.value, 
            ...unavailableInventoryItems.value
        ].reduce((acc, item) => {
            acc[item.list_item_id] = true;
            return acc;
        }, {});
        return arr;
    });

    let gridItems = computed({
        get: () =>
            items.value.map((item) => {
                return {
                    data: {
                        ...item,
                        item_name: item.variation.item?.name,
                        item_no: item.variation.rothcoItem?.rothco_item_no,
                        seo_name: item.variation.item?.seo_name,
                        variants_text: Object.values(item?.variation?.text_description ?? {}).join(" - "),
                        variants_badges: item.variation.text_description,
                        quantity: item.quantity,
                        item_error: !!restrictedItems.value.find((restrictedItem) => restrictedItem.list_item_id == item.list_item_id)
                    },
                    list_item_id: item.list_item_id
                };
            }),
        set: (value) => {
            items.value = value;
        }
    });

    const visibleFields = computed(()=>{
        return [
            {
                label: "Item Name",
                field: "item_name",
                is_custom: true,
                show_only: 'mobile',
                pt: {
                    headerCell: { class: 'text-left' },
                    bodyCell: { class: 'mob-w-100 no-title', 'data-label': "Item" }
                }
            },
            {
                label: "Item Name",
                field: "item_name",
                is_custom: true,
                show_only: 'desktop',
                pt: {
                    headerCell: { class: 'text-left' },
                    bodyCell: { 'data-label': "Item" }
                }
            },
            {
                label: "Item #",
                field: "item_no",
                is_custom: false,
                pt: {
                    headerCell: { class: 'text-left' },
                    bodyCell: { class: 'mob-w-25 align-top', 'data-label': "Item" },
                }
            },
            {
                label: "Variant",
                field: "variants_text",
                is_custom: false,
                show_only: 'desktop',
                pt: {
                    headerCell: { class: 'text-left' },
                    bodyCell: { class: 'mob-w-75' }
                }
            },
            {
                label: "Variant",
                field: "variants_badges",
                is_custom: true,
                show_only: 'mobile',
                pt: {
                    bodyCell: { class: 'mob-w-75', 'data-label': "Variation" }
                }
            },
            {
                label: "Unit Price",
                field: "price",
                is_custom: true,
                pt: {
                    headerCell: { class: 'text-right' },
                    bodyCell: { class: 'mob-w-25 desk-text-right', 'data-label': "Unit Price" }
                }
            },
            {
                label: "Qty",
                field: "quantity",
                is_custom: true,
                show_only: 'desktop',
                editable: true,
                pt: {
                    headerCell: { class: 'text-right' },
                    bodyCell: (state)=>{
                        return { 
                            class: 'qty-cell mob-w-25 desk-text-right desktop-only', 
                            'data-label': "Qty",
                            id: `quantity_${state.instance.rowData.list_item_id}_desktop`  
                        }
                    }
                }
            },
            {
                label: "Cost",
                field: "cost",
                is_custom: true,
                show_only: 'mobile',
                pt: {
                    headerCell: { class: 'text-right' },
                    bodyCell: { 
                        class: 'mob-w-25 mob-text-left desk-text-right',
                        'data-label': "Cost" 
                    }
                }
            },
            {
                label: "Qty",
                field: "quantity",
                is_custom: true,
                show_only: 'mobile',
                editable: true,
                pt: {
                    bodyCell: (state)=>{
                        return { 
                            class: 'qty-cell mob-w-25 mobile-only', 
                            'data-label': "Qty",
                            id: `quantity_${state.instance.rowData.list_item_id}_mobile`
                        }
                    }
                }
            },
            {
                label: "Cost",
                field: "cost",
                is_custom: true,
                show_only: 'desktop',
                pt: {
                    headerCell: { class: 'text-right' },
                    bodyCell: { 
                        class: 'mob-w-25 mob-text-left desk-text-right',
                        'data-label': "Cost" 
                    }
                }
            },
            {
                label: "Delete",
                field: "delete",
                is_custom: true,
                show_only: "desktop",
                visible: !props.addingItems,
                pt: {
                    headerCell: { class: 'title-xs text-center' },
                }
            },
        ]
    })


    let tableRef = ref();

    function validateQuantity(qty) {
        return !Number.isNaN(+qty) && +qty >= 0 && +qty % 1 == 0;
    }

    const handleQuantityInput = (updatedItem)=>{
        const index = items.value.findIndex((i) => i.list_item_id == updatedItem.list_item_id);
        let oldItem = JSON.parse(JSON.stringify(items.value[index]));
        
        if(updatedItem.quantity == 0) {
            return deleteItem(updatedItem);
        }
        items.value[index].quantity = updatedItem.quantity;
        if(!validateQuantity(updatedItem.quantity)) return;
        if(updatedItem.quantity != oldItem.quantity){
            updateListItemQuantity({
                list_item_id: updatedItem.list_item_id,
                quantity: updatedItem.quantity
            });
        }
    }

    let { updateListItem } = useLists({ router, route });

    function updateListItemQuantity({ list_item_id, quantity }) {
        updateListItem(
            { list_item_id, quantity },
            {
            async afterFetch(ctx) {
                   return new Promise(async (resolve) => {
                        const index = items.value.findIndex((i) => i.list_item_id == list_item_id);
                        items.value[index].quantity = quantity;
                        router.reload({
                            only: ['current_list', 'mustShip'],
                            onFinish: async () => {
                                shippingConfirm.value.validate();
                                await execute();
                                resolve(true);
                            }
                        })
                        resolve(ctx);
                    });
                }
            }
        );
        // router.reload();
    }

    let dialog = useDialog();

    function deleteItem(item) {
        dialog.open(ListDeleteForm, {
            props: {
                modal: true,
                header: "Delete List Item",
                showHeader: false,
                style: {
                    width: "50vw"
                }
            },
            data: {
                type: "item",
                list_item_id: item.list_item_id,
                beforeCloseForItem(ctx) {
                    return new Promise((resolve) => {
                        router.reload({
                            only: ['current_list', 'items'],
                            onFinish: async () => {
                                await execute();
                                resolve(true);
                            }
                        });
                    });
                }
            },
            onClose: (props) => {
                if(props?.data?.cancelled){
                    let id = item.list_item_id;
                    let index = items.value.findIndex((listItem)=>(listItem.list_item_id == id));
                    if(index > -1){
                        const input = document.getElementById(`quantity_${id}_input`);
                        if(input) input.value = items.value[index].quantity;
                    }
                }
            }
        });
    }
    function isRestricted(data) {
        return restrictedItems.value.find(
            (item) => item.list_item_id == data.list_item_id
        );
    }
    function hasUnavailableInventory(item) {
        if (billing.value.order_type == "Order") {
            let listItemQuantity = +item.quantity
            if(!Number.isNaN(listItemQuantity)){
                return listItemQuantity > item.variation.inventory_level;
            }
            return false;
        }
        return false;
    }

    function convertToQuote() {
        billing.value.order_type = "Quote";
    }

    const isQuote = computed(()=>{
        return billing.value.order_type == "Quote";
    })

    function changeQuantity(id) {
        let qtyCellDesktop = document.getElementById(`quantity_${id}_desktop`);
        let qtyCellMobile =  document.getElementById(`quantity_${id}_mobile`);
        let isMobile = getComputedStyle(qtyCellDesktop).getPropertyValue('display') == 'none';

        (isMobile ? qtyCellMobile : qtyCellDesktop)?.click();
        nextTick(() => {
            (isMobile ? qtyCellMobile : qtyCellDesktop).querySelector(`#quantity_${id}_input`)?.focus?.();
        });
    }

    let settings = useSettingsStore();

    let { allow_restricted_items: allowRestrictedItems } = storeToRefs(settings);

    function getRestrictionMessage(item) {
        let restrictions = restrictionData.value?.data?.skus;
        if (restrictions) {
            let restrictedSku = restrictions.find(
                (restriction) => restriction.upc == item.variation.upc
            );
            let isHardRestriction = restrictedSku?.has_hard_restrictions;
            let isSoftRestriction =
                restrictedSku?.is_restricted && !isHardRestriction;

            if (
                isHardRestriction || (isSoftRestriction && !allowRestrictedItems.value)
            ) {
                return `This product is under a sales restriction. Please remove from cart to continue.`;
            }
             else if(restrictedSku?.is_restricted) {
                return `This product is restricted. Placing an order with this product will place your order on hold for review.`;
            }
        }
        return "";
    }

    function blurOnWheel(event) {
        event.target.blur();
    }

    let checkoutStoreRoute = computed(()=>{
        return route('checkout.store');
    })


    function pdpRoute(item) {
        return route('productDetail.show', [item.data.seo_name])
    }

    const prop65Items = computed(()=>{
        return items.value.filter((item)=>(item?.prop_65_specs?.length > 0));
    })
    const openProp65Modal = ()=>{
        dialog.open(Prop65OrderWarningModal, {
            props: {
                showHeader: false,
                modal: true
            },
            data: {
                prop65Items: prop65Items.value
            }
        });
    }

    const documentReady = ref(false);

    let { gtmCustomEvent } = useGoogleManager();
    onMounted(()=>{
        documentReady.value = !!document.body;

        gtmCustomEvent('b2b_checkout_confirm_screen');
        gtmCustomEvent('begin_checkout', {
            currency: 'USD',
            value: merchandiseCost.value,
            items: items.value.map((item) => ({
                item_name: item.variation.item.name,
                item_id:item.variation.rothcoItem.rothco_item_no,
                price: item.price,
                quantity: item.quantity,
                variant: getVariant(item.variation.text_description)
            }))
        })
        if(prop65Items.value.length > 0){
            openProp65Modal();
        }
    })
    
</script>
